<script setup lang="ts">
// 樣式吃全域 ui.css 的 .btn；此處只補 block / loading spinner。
// ⚠️ 未給 variant 一律 fallback 到 `ghost`（見下方 template）——**別改這個預設**：
//    整個 console 有 60 幾顆沒標 variant 的按鈕靠它，改一個字會全部換樣子。
//    要有框的次要按鈕請顯式標 `secondary`。
defineProps<{
  variant?: 'primary' | 'danger' | 'secondary' | 'warn' | 'ghost'
  size?: 'sm' | 'md'
  block?: boolean
  loading?: boolean
  disabled?: boolean
}>()
</script>

<template>
  <button
    :class="['btn', variant ?? 'ghost', { sm: size === 'sm', block, 'is-loading': loading }]"
    :disabled="disabled || loading"
  >
    <span v-if="loading" class="btn-spin" aria-hidden="true" />
    <slot />
  </button>
</template>

<style scoped>
.btn-spin {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 6px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  vertical-align: -1px;
  animation: btnspin 0.6s linear infinite;
}
@keyframes btnspin {
  to {
    transform: rotate(360deg);
  }
}
</style>
